import { useDispatch } from 'react-redux'

import { TableList, TableColumns } from 'components/common'
import BuildingLevelApi, { getDetailUrl, pkField } from 'models/BuildingLevel/api'
import { BuildingLevelActions } from 'models/BuildingLevel/slice'
import { BuildingLevelValue } from 'models/BuildingLevel/components'


const defaultColumnList = ['name', 'sort', 'isActive', 'actions'];


const BuildingLevelList = ({ columnList, params, filterParams, onEdit }) => {
  const [apiGetList, apiGetListProps] = BuildingLevelApi.endpoints.getBuildingLevelList.useLazyQuery();
  const [apiUpdate, apiUpdateProps] = BuildingLevelApi.endpoints.updateBuildingLevel.useMutation();
  const [apiDelete, apiDeleteProps] = BuildingLevelApi.endpoints.deleteBuildingLevel.useMutation();
  const [apiBatchDelete, apiBatchDeleteProps] = BuildingLevelApi.endpoints.batchDeleteBuildingLevel.useMutation();

  const dispatch = useDispatch();

  const fields = {
    name: {
      title: 'Название',
      sorter: true,
      render: (val, item) => (<BuildingLevelValue detail={item} asLink={true} isBack={true} />),
    },
    sort: { title: 'Сортировка', sorter: true, width: 130 },
    isActive: TableColumns.getColumnOnOff({ title: 'Активно', fieldName: 'isActive', apiUpdate, apiUpdateProps }),

    actions: TableColumns.getColumnActions({
      getDetailUrl,
      getActions: (item) => [
        { name: 'edit', action: () => dispatch(BuildingLevelActions.openForm({ name: 'editForm', pk: item[pkField] })) },
        { name: 'delete', action: () => apiDelete(item[pkField]) },
      ]
    }),
  };

  return (
    <TableList
      queryKey="buildingLevel"
      rowKey={pkField}
      params={params}
      filterParams={filterParams}
      fields={fields}
      columnList={columnList || defaultColumnList}

      apiGetList={apiGetList}
      apiGetListProps={apiGetListProps}
      apiUpdateProps={apiUpdateProps}
      apiDeleteProps={apiDeleteProps}
      apiBatchDelete={apiBatchDelete}
      apiBatchDeleteProps={apiBatchDeleteProps}
      onEdit={onEdit}

      rowSelection={false}
      hidePagination={false}
      hideStat={false}
    />
  );
}

export default BuildingLevelList;
